<template>
  <div class="beefCont">
    <img src="../assets/imgs/96/bg.jpg" class="bg" alt="" />
    <Qrcode :pic="96" />
    <div class="phoneCommon">
        咨询电话：<a href="tel:028-87516998" style="color:#fff">028-87516998</a>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "@/assets/public.scss";
.beefCont {
  width: 100vw;
  position: relative;
  .bg {
    width: 100%;
    height: 88.94rem;
    display: block;
  }
}
</style>